/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const transfer_to = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#000"
      d="m11.466 1.062.323.677-.323-.677Zm.884.392-.719.215.719-.215ZM1 8.584a.75.75 0 0 0 0 1.5v-1.5Zm2.651 1.81a.75.75 0 0 0 1.061 1.061l-1.06-1.06Zm2.122-1.06.53.53a.75.75 0 0 0 0-1.06l-.53.53Zm-1.06-2.121a.75.75 0 0 0-1.062 1.06l1.061-1.06Zm-2.86-3.125a.75.75 0 1 0 1.255.824l-1.254-.824Zm1.386 9.806a.75.75 0 1 0-.883 1.212l.883-1.212Zm10.488.1H3.545v1.5h10.182v-1.5Zm0 1.5a2.023 2.023 0 0 0 2.023-2.024h-1.5a.523.523 0 0 1-.523.523v1.5Zm0-10.819c.289 0 .523.234.523.523h1.5a2.023 2.023 0 0 0-2.023-2.023v1.5Zm-10.182 0h1.91v-1.5h-1.91v1.5Zm2.232-.073 6.012-2.863-.645-1.354-6.012 2.863.645 1.354Zm-.322.073h7.636v-1.5H5.455v1.5Zm7.636 0h.636v-1.5h-.636v1.5Zm-1.46-3.006.742 2.471 1.436-.43-.741-2.472-1.437.431Zm.158.07a.114.114 0 0 1-.158-.07l1.437-.43a1.386 1.386 0 0 0-1.924-.854l.645 1.354Zm2.461 3.459v8.272h1.5V5.198h-1.5Zm-9.538 6.257 1.591-1.59-1.06-1.061-1.592 1.59 1.061 1.061Zm1.591-2.651-1.59-1.591-1.062 1.06 1.591 1.591 1.061-1.06ZM1 10.084h4.773v-1.5H1v1.5Zm2.545-6.909c-.708 0-1.331.365-1.691.913l1.254.824a.522.522 0 0 1 .437-.237v-1.5Zm0 10.818a.517.517 0 0 1-.306-.1l-.883 1.213c.334.244.746.387 1.19.387v-1.5Z"
    />
  </svg>
)
export default transfer_to
